import { PulseLoader } from '@sparemin/blockhead';
import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import Modal from 'components/Modal';
import VideoTemplateEditor, {
  VideoTemplateEditorFeatures,
} from 'components/VideoTemplateEditor';

import {
  embedExportsSelector,
  makeProjectDetailSelector,
} from 'redux/modules/entities';
import { IEmbedConfig } from 'types';
import EditTemplateModalHeader from './EditTemplateModalHeader';
import useEditTemplateModalEditor from './useEditTemplateModalEditor';
import { block } from './utils';

export interface EditTemplateModalContentsProps {
  projectId?: string;
  features?: VideoTemplateEditorFeatures;
  isShortFormProject?: boolean;
  embedConfig: IEmbedConfig;
}

const EditTemplateModalContents: React.FC<EditTemplateModalContentsProps> = ({
  projectId,
  features,
  isShortFormProject,
  embedConfig,
}) => {
  const { projectConfig, podcastSource } =
    useSelector(
      useMemo(() => makeProjectDetailSelector(projectId), [projectId]),
    ) ?? {};
  const exportStatus = useSelector(embedExportsSelector);

  const {
    editorState,
    integrations,
    templateEditorFeatures,
    transcription,
    imageProcessorStatus,
    onSave,
    onChange,
    onCancel,
  } = useEditTemplateModalEditor({
    embedConfig,
    features,
    isShortFormProject,
  });

  return (
    <Modal.Body className={block('contents')}>
      <EditTemplateModalHeader {...{ onSave, onCancel }} />

      {!editorState ? (
        <div className={block('loader-container')}>
          <PulseLoader />
        </div>
      ) : (
        <VideoTemplateEditor
          {...{
            integrations,
            transcription,
            onChange,
          }}
          features={templateEditorFeatures}
          eddyProjectVisibility="hidden"
          projectName={projectConfig?.projectName}
          podcastIdentifier={{
            podcastId: String(podcastSource?.podcastFeedId),
            episodeId: String(podcastSource?.remotePodcastEpisodeId),
          }}
          media={{
            type: 'video',
            source: exportStatus
              .find(entry => entry.get('referrerProjectId') === projectId)
              ?.get('videoUrl'),
          }}
          defaultEmbedConfig={isShortFormProject ? undefined : embedConfig}
          allowCaptionsManagement={!isShortFormProject}
          state={editorState}
          loading={imageProcessorStatus === 'processing'}
          showControls={false}
          className={block('template-editor')}
          renderCta={() => null}
        />
      )}
    </Modal.Body>
  );
};

export default EditTemplateModalContents;
